var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-column",
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "d-flex flex-column flex-grow-1"
  }, [_c('v-tabs', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "vertical": "",
      "background-color": "grey lighten-4"
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _vm.isLoading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-column flex-grow-1",
    staticStyle: {
      "min-height": "0"
    }
  }, [_vm._l(_vm.tabs, function (tab) {
    return _c('v-tab', {
      key: tab.value
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v(_vm._s(tab.icon || _vm.defaultIcon))]), _vm._v(" " + _vm._s(tab.value) + " ")], 1);
  }), _c('div', {
    staticClass: "mt-auto px-2 pb-2"
  }, [_vm._t("actions", null, null, {
    isMobile: _vm.isMobile
  })], 2)], 2), _vm._l(_vm.tabs, function (tab) {
    return _c('v-tab-item', {
      key: "item-".concat(tab.id)
    }, [_vm._t("default", null, null, {
      tab: tab
    }), _vm._t("tab-".concat(tab.id), null, null, {
      tab: tab
    })], 2);
  })], 2)], 1) : _c('div', {
    staticClass: "d-flex flex-row align-center grey lighten-4"
  }, [_c('div', {
    staticClass: "flex-grow-1 overflow-x-auto",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('v-tabs', {
    attrs: {
      "background-color": "grey lighten-4",
      "grow": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _vm._l(_vm.tabs, function (tab) {
    return _c('v-tab', {
      key: tab.value
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v(_vm._s(tab.icon || _vm.defaultIcon))]), _c('v-list-item-title', [_vm._v(_vm._s(tab.value))])], 1);
  })], 2)], 1), _vm.$slots.actions ? _c('context-menu', [_vm._t("actions", null, null, {
    isMobile: _vm.isMobile
  })], 2) : _vm._e()], 1), _vm.isMobile ? _c('div', {
    staticClass: "flex-grow-1 overflow-y-auto"
  }, [_c('v-tabs-items', {
    staticClass: "fill-height",
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.tabs, function (tabItem) {
    return _c('v-tab-item', {
      key: "item-mobile-".concat(tabItem.value)
    }, [_vm._t("default", null, null, {
      tab: tabItem
    }), _vm._t("tab-".concat(tabItem.id), null, null, {
      tab: tabItem
    })], 2);
  }), 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }